// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageUpload__TooltipButton {
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.ImageUpload__Image {
  display: block;
  width: 100%;
  margin-bottom: 2rem;
}
.ImageUpload__ButtonWrapper {
  display: flex;
  align-items: flex-end;
  margin-top: 1rem;
}
.ImageUpload__Button {
  flex: 1;
}
.ImageUpload__Button:first-of-type {
  margin-right: 1rem;
}
.ImageUpload__Button--disabled {
  background: gray;
  pointer-events: none;
}
.ImageUpload input:focus {
  outline: none;
}
.ImageUpload h2 {
  margin-top: 0;
  margin-bottom: 2em;
}`, "",{"version":3,"sources":["webpack://./libs/features/shared/components/src/lib/property-image/upload-form/upload-form.component.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,cAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,OAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;AAMI;EACE,gBAAA;EACA,oBAAA;AAJN;AASI;EACE,aAAA;AAPN;AAWE;EACE,aAAA;EACA,kBAAA;AATJ","sourcesContent":[".ImageUpload {\n  &__TooltipButton {\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n  }\n\n  &__Image {\n    display: block;\n    width: 100%;\n    margin-bottom: 2rem;\n  }\n\n  &__ButtonWrapper {\n    display: flex;\n    align-items: flex-end;\n    margin-top: 1rem;\n  }\n\n  &__Button {\n    flex: 1;\n\n    &:first-of-type {\n      margin-right: 1rem;\n    }\n\n    &--disabled {\n      background: gray;\n      pointer-events: none;\n    }\n  }\n\n  input {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  h2 {\n    margin-top: 0;\n    margin-bottom: 2em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
